export default __webpack_public_path__ + "static/media/SimulatorOn.c79addf4.svg";